document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth >= 767) return;

  const carousels = document.querySelectorAll(".figma-card-carousel");

  carousels.forEach(function (carousel) {

    const track = carousel.querySelector(".figma-card-row");
    const slides = carousel.querySelectorAll(".figma-card");
    const prevBtn = carousel.querySelector(".slider-arrow.prev");
    const nextBtn = carousel.querySelector(".slider-arrow.next");

    if (!track || slides.length === 0) return;

    let index = 0;
    const total = slides.length;

    function updateSlider() {
      track.style.transform = "translateX(-" + (index * 100) + "%)";
    }

    nextBtn.addEventListener("click", function () {
      if (index < total - 1) {
        index++;
        updateSlider();
      }
    });

    prevBtn.addEventListener("click", function () {
      if (index > 0) {
        index--;
        updateSlider();
      }
    });

    /* Swipe */
    let startX = 0;

    track.addEventListener("touchstart", function (e) {
      startX = e.touches[0].clientX;
    });

    track.addEventListener("touchend", function (e) {
      let endX = e.changedTouches[0].clientX;
      let diff = startX - endX;

      if (diff > 50 && index < total - 1) {
        index++;
      } else if (diff < -50 && index > 0) {
        index--;
      }

      updateSlider();
    });

  });

});